import { put, call } from 'redux-saga/effects';
import { trackUserLogin } from 'src/helpers/googleAnalytics/events';
import { updateCurrentTimezone } from 'src/helpers/dateTime';
import ApiInstance from '../../helpers/apiInstance';
import { sendRequest } from '../../helpers/saga';
import actions from './actions';
import { IUserProfileApiResponse } from './types';
import authActions from '../auth/actions';

const api = new ApiInstance('user');

function* userProfileRequest() {
  const result: IUserProfileApiResponse = yield call(sendRequest, api.get, {}, actions.USER_PROFILE_ERROR);

  if (result?.status === 200 && result.data) {
    const { email, countries, id, time_zone, intercom, role, first_name, last_name, avatar_url, selected_country } =
      result.data.user;

    const profile = { name: first_name, lastName: last_name, email, avatar_url };
    trackUserLogin({ profile, role });
    updateCurrentTimezone(time_zone);

    yield put({
      type: authActions.LOGIN_SUCCESS,
      payload: {
        isLoggedIn: true,
        countries,
        id,
        intercom,
        profile,
        role: role.id,
        selectedCountry: {
          id: selected_country.id,
          name: selected_country.name,
          code: '', // selected_country.code,
          currency: '', // selected_country.currency,
        },
        time_zone,
        username: email,
      },
    });

    yield put(actions.userProfileSuccess(result.data));
  }
}

export { userProfileRequest };
